"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageFormat = MessageFormat;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

function MessageFormat(params) {
  var record = params.data;
  var hasComment = !!record.comment;
  return hasComment ? /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return params.colDef.clickFunction(record.comment);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "sms",
    className: "sms-icon"
  })) : null;
}